<template>
    <div>
        <v-app class="p-4">
            <div class="col-md-12 p-0 mt-12 pt-12 mx-auto" style="border: none!important;">
                <div class="my-4">
                    <users-component></users-component>
                </div>

                <date-picker auto-submit type="datetime"
                             format="YYYY-MM-DD HH:mm"
                             display-format="jYYYY-jMM-jDD HH:mm"
                             :timezone="false"
                             v-model="expire_date"
                             label="تاریخ انقضا"
                             endTime>
                </date-picker>

                <v-textarea
                        rows="10"
                        class="my-6"
                        label="شماره ها"
                        outlined
                        v-model="phones"
                        clear-icon="mdi-close-circle-outline"
                        clearable
                        dense>
                </v-textarea>

                <v-btn class="submit-btn" @click="submit">
                    ثبت
                </v-btn>
            </div>
        </v-app>
    </div>
</template>

<script>
import UsersComponent from "./UsersComponent";
import {Bus} from "../../../main";

export default {
    name: "UserNumberPack",
    components: {UsersComponent},
    data() {
        return {
            url: `${url}/admin/packs/new`,
            user_id: undefined,
            phones: undefined,
            expire_date: undefined,
        }
    },
    methods: {
        submit() {
            $.ajax({
                url: this.url,
                type: 'POST',
                data: JSON.stringify({
                    user_id: this.user_id,
                    phones: this.phones,
                    expire_date: this.expire_date,
                }),
                headers: {
                    "ACCEPT": 'application/json',
                    "Authorization": Token,
                    "Content-Type": 'application/json'
                },
                msg: true,
                success: () => {
                    this.expire_date = undefined;
                }
            })
        }
    },
    mounted() {
        Bus.$on('manufacturersPicker', (val) => {
            this.user_id = val;
        })
    }
}
</script>

<style scoped>

</style>